module.exports = __webpack_public_path__ + "static/media/icon_black.d73237cc.png";